import { Grid } from "./grid";
import { FrontViewLayer } from "../FrontViewLayer";
import { ScrollWindow } from "../ScrollWindow";
import { Utils } from "../utils/Utils";
import { ActionState, ActionStateEnum, UiState, FrontViewState, UiFrontViewState, IdleConstruction, IdleDecoration, SelectableElementsState, AddEntityState, EditEntitiesState, IdleCameraState,
    RoomsValidationState, SelectedOrderRoom, AbsoluteIdleState, QuotationState, WorkTopState, AreaState, AddRoomState, FrontViewAddJoinery, AddJoineryState, FrontViewAddEntity, EditEntityState
 } from "../state";

import { IdleVisualiseState } from "../state/actionState/IdleVisualiseState";
import { VisualisePlanState } from "../state/uiState/VisualisePlanState";
import { GameObjectManager } from "./GameObjectManager";
import { CocosConstants, Command } from "../../../constants";
import { EntityManager } from "./EntityManager";
import { EntityNode } from "./EntityNodes/EntityNode";
import { CocosUtils } from "../../../cocosPlan";
import { ArrangementObject, Commands, ComponentConstants, Entity, EntityDefaultPropertiesManager, EntityFactory, Event, Events, eventsManager, Floor, Functionality, GeometryPrimitive, Joinery, joineryManager, JSONSerializer, KitchenTool, Listener, math, planManager, RenderCamera, Room, roomManager, SavaneCookie, Scene, SceneConstants, Staircase, TechnicalElement, TemplateImage, Wall, World } from "@rhinov/savane-js";
import { isForB2B } from "@rhinov/asset-manager-service";

declare var cc: any;
declare var $: any;

export const ButtonId = {
    wall: 0,
    door: 1,
    frenchWindow: 2,
    opening: 3,
    pictureWindow: 4,
    window: 5,
    room: 6,
    roomL: 7,
    roomL90: 8,
    roomL180: 9,
    roomL270: 10,
    arrangementButton: 11,
    selectionTemplate: 12,
    componentSprite: 13,
    walls: 14,
    stove: 15,
    fireplace: 16,
    pole: 17,
    boiler: 18,
    serviceShaft: 19,
    radiator: 20,
    straight: 21,
    quarterTurn: 22,
    doubleQuarterTurn: 23,
    circular: 24,
    canopy: 25,
    cupboardDoor: 26,
    garageDoor: 27,
    divider: 28,
    frontDoor: 29,
    camera: 30,
    waterSource: 31,
    niche: 32,
    area: 33,
    switchBoard: 34,
    socketTV: 35,
    socketSixteen: 36,
    socketThirtyTwo: 37,
    wardRobe: 38,
    airConditioner: 39,
    spotLight: 40,
    beam: 41,
    fixedWindow: 42,
    velux: 43,
    rosette: 44,
    frame: 45,
    wallDecoration: 46,
    actionDelete: -42
};

var wallObjectThickness = 0.1

export const Plan2DConstantes = {
    wallObjectThickness: wallObjectThickness,
    minDistForChangingSize: 0.02,
    usermapColorMask: new cc.Color(200, 200, 200, 128),
    wallvec4NotValid: new cc.Color(255, 0, 0, 255),
    wallvec4Valid: new cc.Color(204, 204, 204, 255),
    wallvec4Selected: new cc.Color(104, 204, 104, 255),
    arrangementvec4NotValid: new cc.Color(255, 0, 0, 1),
    arrangementvec4Valid: new cc.Color(255, 255, 255, 0),
    arrangementvec4Selected: new cc.Color(150, 150, 150, 0),
    arrangementvec4Hover: new cc.Color(175, 175, 175, 0),
    joineryvec4NotValid: new cc.Color(189, 45, 47, 125),
    joineryvec4Valid: new cc.Color(255, 255, 255, 255),
    joineryvec4Selected: new cc.Color(104, 204, 104, 255),
    gridLineColor: new cc.color(192, 192, 192, 255),
    gridBackgroundColor: new cc.color(255, 255, 255, 255),
    joineryOverlapColorValid: new cc.Color(51, 51, 51, 69),
    joineryOverlapColorNotValid: new cc.Color(255, 0, 0, 69),
    joineryOverlapBorderColor: new cc.Color(255, 255, 255, 255),
    joineryObjectThickness: 0.2 * wallObjectThickness,
    wallAnimationCreationTimeOut: 2,
    wallCreationPressedTimeOut: 2,


    defaultTextureScale: 0.002
    // tileTextureScale: 50 * Assets.Scripts.Plan2DConstantes.wallObjectThickness,
    // gridBigvec4: new Assets.Scripts.Bridge.vec4('constructor$1', 0.1, 0.1, 0.1, 0.2),
    // gridSmallvec4: new Assets.Scripts.Bridge.vec4('constructor$1', 0.01, 0.01, 0.01, 0.5),
};

export class PlanManager {
    private static _instance: PlanManager | null = null;
    
    _actionCount: number = 0;
    deliverableID: number = 0;
    /*var scope = angular.element($('#saveProject')).scope();
    scope.safeApply(function () {
    scope.disableSaveProject = this._actionCount === 0;
    }.bind(this));*/
    _lastIndexActionDone: {[key: number]: number} = { 0: -1 };
    joineriesLength: number[] = [];
    
    _mustShowGrid: boolean = true;
    _mustShowRoomName: boolean = true;
    _mustShowRoomArea: boolean = true;
    _mustShowPlan: boolean = true;
    _areRulersActive: boolean = true;
    autoCache: boolean = true; // If set to true will handle the cache automatically
    user: any = null;
    scrollWindow: ScrollWindow;
    frontViewLayer: FrontViewLayer;

    frontViewDrawMode: number = 0;
    selectedSVGBrush: any = null;

    _lastActions: {[key: number]: any[]} = { 0: [] };
    /*this._uiState = new UiIdleState();
    this._state = new IdleEditState();*/
    _uiState: UiState = new VisualisePlanState(null, null);
    _state: ActionState = new IdleVisualiseState(true) as unknown as ActionState;
    _backgroundVisibility: boolean = false;

    _wallWireframe: boolean = false;
    _hideAxo: boolean = false;
    _hideArrangements: boolean = false;

    _opacity: {min: number, value: number, max: number} = {
        min: 0,
        value: 75,
        max: 255,
    };
    _vectorDraw: number = 0;
    _opacityFloors: {min: number, value: number, max: number} = {
        min: 0,
        value: 75,
        max: 255,
    };
    _showDimension: boolean = true;
    snapEnabled: boolean = true;
    magnetRotation: boolean = true;

    mouseButton = null;

    _isCR: boolean = false;
    _isVisioDesignerCR: boolean = false;
    joineryColorEventListener: Listener = new Listener(this.joineryColorCommand.bind(this));

    translationEventListener: Listener = new Listener(this.translationCommand.bind(this));
    symetryEventListener: Listener = new Listener(this.symetryCommand.bind(this));
    rotationEventListener: Listener = new Listener(this.rotationCommand.bind(this));
    scaleEventListener: Listener = new Listener(this.scaleCommand.bind(this));
    setFloorHeightEventListener: Listener = new Listener(this.setFloorHeightCommand.bind(this));
    setProjectFloorHeightEventListener: Listener = new Listener(this.setProjectFloorHeightCommand.bind(this));
    setRoomFloorHeightEventListener: Listener = new Listener(this.setRoomFloorHeightCommand.bind(this));
    setFloorCornicesEventListener: Listener = new Listener(this.setFloorCornicesCommand.bind(this));
    setProjectCornicesEventListener: Listener = new Listener(this.setProjectCornicesCommand.bind(this));
    undoEventListener: Listener = new Listener(this.undoCommand.bind(this));
    redoEventlistener: Listener = new Listener(this.redoCommand.bind(this));
    dimensionsListener: Listener = new Listener(function(event: any) {
        PlanManager.getInstance().showDimension = event.getUserData();
        PlanManager.getInstance().showDimension = false;
    });
    hideBackground: Listener = new Listener(this.changeBackgroundVisibility.bind(this));
    tollThicknessListener: Listener | null = eventsManager.instance.addListener(Events.EDIT_TOOL_THICKNESS, this.changeThicknessTool.bind(this));
    mainFuncListener: Listener = new Listener(this.updateCurrentRoomMainFunctionality.bind(this));
    sketchModeListener: Listener | null = eventsManager.instance.addListener(Events.TOGGLE_SKETCH_MODE, function(datas: any) {
        CocosConstants.sketchMode = datas.getUserData() === null ? !CocosConstants.sketchMode : datas.getUserData();
    });

    debounceChangeRoomFunctionality: any = null;

    floorChangeListener: Listener | null = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, function() {
        //Change plan pic if floor provide one
        var backPlan = PlanManager.getInstance().world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage) as TemplateImage;
        if (backPlan !== null) {
            GameObjectManager.createUserMap(backPlan.url, backPlan.scale, backPlan.userScale, backPlan.rotation, backPlan.offset);

            // Tutorial start
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 4);
            // Tutorial End
        } else {
            GameObjectManager.deleteUserMap();
        }
    });

    planUploadListener: Listener | null = eventsManager.instance.addListener(Events.PLAN_UPLOADED, function() {
        //Change plan pic if floor provide one
        var backPlan = PlanManager.getInstance().world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage) as TemplateImage;
        if (backPlan !== null) {
            GameObjectManager.createUserMap(backPlan.url, backPlan.scale, backPlan.userScale, backPlan.rotation, backPlan.offset);
        } else {
            GameObjectManager.deleteUserMap();
        }
    });

    //Func chips hidder
    hideChips: boolean = false;
    hideListener: Listener | null = eventsManager.instance.addListener(Events.HIDE_CHIPS, function(this: PlanManager, event: any) {
        this.hideChips = true;
    }.bind(this));

    //Show/hide user pictures on plan
    showUserPictures: boolean = true;
    togglePictures: Listener | null = eventsManager.instance.addListener(Events.TOGGLE_USER_PICTURES, function(this: PlanManager, event: any) {
        this.showUserPictures = event.userData;
    }.bind(this));

    //Add listener of changing state
    changeStateListener: Listener = new Listener(function(this: PlanManager, datas: any) {
        var state = datas.userData;
        if (state) {
            this._state.dispose();
            this._state = state;
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, this.getAction());
        }
    }.bind(this));

    changeEditorSelectionListener: Listener | null = eventsManager.instance.addListener(Events.CHANGE_EDITOR_SELECTION, function(this: PlanManager, datas: any) {
        this.updateItemsSelected(datas.getUserData().selection, datas.getUserData().keepSelected, datas.getUserData().showTulip);
    }.bind(this));

    unselectEditorSelectionListener: Listener | null = eventsManager.instance.addListener(Events.UNSELECT_EDITOR_SELECTION, function(datas: any) {
        var entity = datas.getUserData().unselectedEntity;

        var node = EntityManager.getInstance().getNode(entity);
        if (node !== null) {
            // If the node is selected, unselect it
            if (node.isSelected()) {
                // No selection at the end
                PlanManager.getInstance().updateItemsSelected(null, false, false);
            }
        }
    }.bind(this));

    cleanWorldTemplateListener: Listener | null = eventsManager.instance.addListener(Events.CLEAN_WORLD_TEMPLATE, function(datas: any) {
        CocosUtils.cleanWorldTemplates();
    }.bind(this));

    //TODO: remove this and pass the template to the addArrangementState
    templateLoad: any = null;
    //TODO : test webservice
    world: World = EntityFactory.getInstance().createWorld();
    _currentFloorId: number = 0;

    // Par défaut on affiche pas le soleil (l'état de la machine a état l'activera [IdleDecoration] ou le désactivera [IdleConstruction])
    showSun: boolean = false;

    functionalitiesAction: number = 0;

    selectedEntities: Entity[] = [];
    lastSelected: Entity | null = null;
    mustShowCamera: boolean = false;
    CanvasMouseX: number = 0;
    CanvasMouseY: number = 0;
    selectedWalls: Wall[] = [];
    highlightMode: boolean = false;
    selectedJoineries: Joinery[] = [];
    

    constructor() {
        this.joineriesLength[SceneConstants.JoineryType.door] = SceneConstants.DefaultShortJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.opening] = SceneConstants.DefaultShortJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.window] = SceneConstants.DefaultShortJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.frenchWindow] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.pictureWindow] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.cupboardDoor] = SceneConstants.DefaultShortJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.garageDoor] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.canopy] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.niche] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.fixedWindow] = SceneConstants.DefaultLongJoineryLength;
        this.joineriesLength[SceneConstants.JoineryType.velux] = SceneConstants.DefaultVeluxLength;
            

        // Maximum framebuffer
        var width = 3840, height = 2160;
        var grid = new Grid(width / window.devicePixelRatio, height / window.devicePixelRatio);
        grid.setName('grid');

        this.scrollWindow = new ScrollWindow(new cc.size(width / window.devicePixelRatio, height / window.devicePixelRatio), grid);
        this.scrollWindow.setName('ScrollWindow');
        this.scrollWindow.setTouchEnabled(false);

        this.frontViewLayer = new FrontViewLayer();
        this.frontViewLayer.setName('frontViewLayer');
        this.frontViewLayer.setVisible(false);

    

        Utils.baseZoom = this.scrollWindow.getZoomScale();

        
        this._opacity.value = parseInt(SavaneCookie.getCookie("Rhinov-CocosPlan-BackgroundOpacity", "" + this._opacity.value)); 
        this._vectorDraw = parseInt(SavaneCookie.getCookie("Rhinov-CocosPlan-VectorDraw", "" + this._vectorDraw));
        this._opacityFloors.value = parseInt(SavaneCookie.getCookie("Rhinov-CocosPlan-FloorOpacity", "" + this._opacityFloors.value));
        //Dimension visible toggle
        

        //Event listeners for project transformations
        
        eventsManager.instance.addListenerObject(Events.DO_APPLYJOINERY_COLOR, this.joineryColorEventListener);

        
        eventsManager.instance.addListenerObject(Events.DO_PROJECT_TRANSLATION, this.translationEventListener);
        eventsManager.instance.addListenerObject(Events.DO_PROJECT_SYMETRY, this.symetryEventListener);
        eventsManager.instance.addListenerObject(Events.DO_PROJECT_ROTATION, this.rotationEventListener);
        eventsManager.instance.addListenerObject(Events.DO_PROJECT_SCALE, this.scaleEventListener);
        eventsManager.instance.addListenerObject(Events.DO_SET_FLOOR_HEIGHT, this.setFloorHeightEventListener);
        eventsManager.instance.addListenerObject(Events.DO_SET_PROJECT_FLOOR_HEIGHT, this.setProjectFloorHeightEventListener);
        eventsManager.instance.addListenerObject(Events.DO_SET_ROOM_FLOOR_HEIGHT, this.setRoomFloorHeightEventListener);
        eventsManager.instance.addListenerObject(Events.DO_SET_FLOOR_CORNICES, this.setFloorCornicesEventListener);
        eventsManager.instance.addListenerObject(Events.DO_SET_PROJECT_CORNICES, this.setProjectCornicesEventListener);

        //Event listeners for undo and redo button
        eventsManager.instance.addListenerObject(Events.UNDO_EVENT, this.undoEventListener);
        eventsManager.instance.addListenerObject(Events.REDO_EVENT, this.redoEventlistener);

        eventsManager.instance.addListenerObject(Events.HIDE_DIMENSION_PRESSED, this.dimensionsListener);
        eventsManager.instance.addListenerObject(Events.HIDE_BACKGROUND_PRESSED, this.hideBackground);
        eventsManager.instance.addListenerObject(Events.MAINFUNCTIONALITY_CHANGE, this.mainFuncListener);

        
        eventsManager.instance.addListenerObject(Events.CHANGE_STATE, this.changeStateListener);

        

        //fix if an scene with a  is import in hp (spi with kitchen)
        JSONSerializer.externalSerializeComponents = [KitchenTool.Exporter.exportComponent];
        (JSONSerializer as any).importSerializeComponents = [KitchenTool.Importer.importComponent];
    }

    static getInstance(): PlanManager {
        const g = globalThis as any;
        if (!g.__rhinov_PlanManager_instance) {
            g.__rhinov_PlanManager_instance = new PlanManager;
        }
        return g.__rhinov_PlanManager_instance;
    }

    static deleteInstance() {
        //Remove listeners
        var instance = PlanManager.getInstance();
        instance.dispose();
        instance.sketchModeListener && eventsManager.instance.removeListener(instance.sketchModeListener);
        instance.tollThicknessListener && eventsManager.instance.removeListener(instance.tollThicknessListener);

        eventsManager.instance.removeListener(instance.joineryColorEventListener);

        instance.unselectEditorSelectionListener && eventsManager.instance.removeListener(instance.unselectEditorSelectionListener);
        instance.changeEditorSelectionListener && eventsManager.instance.removeListener(instance.changeEditorSelectionListener);

        eventsManager.instance.removeListener(instance.translationEventListener);
        eventsManager.instance.removeListener(instance.symetryEventListener);
        eventsManager.instance.removeListener(instance.rotationEventListener);
        eventsManager.instance.removeListener(instance.scaleEventListener);
        eventsManager.instance.removeListener(instance.setFloorHeightEventListener);
        eventsManager.instance.removeListener(instance.setRoomFloorHeightEventListener);
        eventsManager.instance.removeListener(instance.setProjectFloorHeightEventListener);
        eventsManager.instance.removeListener(instance.setFloorCornicesEventListener);
        eventsManager.instance.removeListener(instance.setProjectCornicesEventListener);

        eventsManager.instance.removeListener(instance.undoEventListener);
        eventsManager.instance.removeListener(instance.redoEventlistener);
        eventsManager.instance.removeListener(instance.dimensionsListener);
        eventsManager.instance.removeListener(instance.hideBackground);
        eventsManager.instance.removeListener(instance.changeStateListener);
        instance.hideListener && eventsManager.instance.removeListener(instance.hideListener);
        eventsManager.instance.removeListener(instance.mainFuncListener);
        instance.planUploadListener && eventsManager.instance.removeListener(instance.planUploadListener);
        instance.floorChangeListener && eventsManager.instance.removeListener(instance.floorChangeListener);
        //instance.sunAddedListener && eventsManager.instance.removeListener(instance.sunAddedListener);
        //instance.sunRemovedListener && eventsManager.instance.removeListener(instance.sunRemovedListener);
        //eventsManager.instance.removeListener(instance.furnitureHandler);
        //eventsManager.instance.removeListener(instance.closeFrontView);
        instance.togglePictures && eventsManager.instance.removeListener(instance.togglePictures);
        (globalThis as any).__rhinov_PlanManager_instance = null;
    }

    collectArrangements(entity: Entity): ArrangementObject[] {
        var arrangements: ArrangementObject[] = [];

        if (entity.entityType === SceneConstants.EntityType.ArrangementObject) {
            arrangements.push(entity as ArrangementObject);
        }

        for (var i = 0; i < entity.children.length; i++) {
            arrangements = arrangements.concat(this.collectArrangements(entity.children[i]));
        }

        return (arrangements);
    }

    handleFurniture(command: Command) {
        var entities: ArrangementObject[] = [];
        var i;

        switch (command.name()) {
            case Commands.CommandEnum.AddEntityCommand:
                entities = this.collectArrangements((command as Commands.AddEntityCommand).execDatas().entity);
                break;

            case Commands.CommandEnum.EditEntityCommand:
                entities = this.collectArrangements(command.execDatas().entity);
                break;

            case Commands.CommandEnum.DeleteEntityCommand:
                entities = this.collectArrangements(command.execDatas().entity);
                break;

            case Commands.CommandEnum.EditEntitiesCommand:
                for (i = 0; i < command.execDatas().entities.length; i++) {
                    entities = entities.concat(this.collectArrangements(command.execDatas().entities[i]));
                }
                break;

            case Commands.CommandEnum.DeleteEntitiesCommand:
                for (i = 0; i < command.execDatas().entities.length; i++) {
                    entities = entities.concat(this.collectArrangements(command.execDatas().entities[i]));
                }
                break;

            case Commands.CommandEnum.AddEntitiesCommand:
                for (i = 0; i < command.execDatas().entitiesAndParents.length; i++) {
                    entities = entities.concat(this.collectArrangements(command.execDatas().entitiesAndParents[i].entity));
                }
                break;

            case Commands.CommandEnum.ReplaceEntitiesCommand:
                for (i = 0; i < command.execDatas().replacingEntitiesAndParents.length; i++) {
                    entities = entities.concat(this.collectArrangements(command.execDatas().replacingEntitiesAndParents[i].entity));
                }
                for (i = 0; i < command.execDatas().replacedEntities.length; i++) {
                    entities = entities.concat(this.collectArrangements(command.execDatas().replacedEntities[i]));
                }
                break;
        }

        for (i = 0; i < entities.length; i++) {
            var entity = entities[i];
            if (entity.objectType === SceneConstants.ArrangementType.kitchenFurnitureBottom ||
                entity.objectType === SceneConstants.ArrangementType.kitchenFurnitureTop ||
                entity.objectType === SceneConstants.ArrangementType.kitchenFurnitureColumn) {
                KitchenTool.KitchenManager.setFurnitureFinishes(this.world.currentScene!.currentFloor);
                break;
            }
        }
    }

    switchToFrontViewMode(wall: Wall) {
        //change to frontViewState (action/ui)
        this.updateItemsSelected(null);

        this.frontViewLayer.setCurrentWall(wall);
        this.frontViewLayer.setVisible(true);
        this.scrollWindow.setVisible(false);

        if (this._state.getAction() === ActionStateEnum.IdleConstruction || this._state.getAction() === ActionStateEnum.idleDecoration) {
            this._state.dispose();
            let isIdleConstruction = this._state.getAction() === ActionStateEnum.IdleConstruction;
            this._state = new FrontViewState(isIdleConstruction) as unknown as ActionState; //@ts-ignore
            this._uiState = new UiFrontViewState(undefined, undefined);
        }
    }

    switchToNormalMode(idleConstruction: boolean) {
        //back to normal
        this.frontViewLayer.setVisible(false);
        this.scrollWindow.setVisible(true);
        this.updateItemsSelected(null);

        if (this._state.getAction() === ActionStateEnum.FrontView ||
            this._state.getAction() === ActionStateEnum.FrontViewAddArea ||
            this._state.getAction() === ActionStateEnum.FrontViewAddEntity ||
            this._state.getAction() === ActionStateEnum.FrontViewAddJoinery ||
            this._state.getAction() === ActionStateEnum.FrontViewCoating ||
            this._state.getAction() === ActionStateEnum.FrontViewCutArea) {
            this._state.dispose();
            if (idleConstruction) {
                this._state = new IdleConstruction() as unknown as ActionState;
            }
            else {
                this._state = new IdleDecoration() as unknown as ActionState;
            }
            this._uiState = new (SelectableElementsState as any)(undefined as any, undefined as any);
        }

    }

    get mustShowGrid(): boolean {
        return this._mustShowGrid;
    }

    set mustShowGrid(value: boolean) {
        this._mustShowGrid = value;
    }

    get mustShowRoomName(): boolean {
        return this._mustShowRoomName;
    }

    set mustShowRoomName(value: boolean) {
        this._mustShowRoomName = value;
    }

    get mustShowRoomArea(): boolean {
        return this._mustShowRoomArea;
    }

    set mustShowRoomArea(value: boolean) {
        this._mustShowRoomArea = value;
    }

    get mustShowPlan(): boolean {
        return this._mustShowPlan;
    }

    set mustShowPlan(value: boolean) {
        this._mustShowPlan = value;
    }

    get scene(): Scene {
        return this.world.currentScene!;
    }

    set scene(scene: Scene) {
        this.world.currentScene = scene;
    }

    get sceneIndex(): number {
        for (var i = 0; i < this.world.children.length; ++i) {
            if (this.world.children[i].id === this.world.currentScene!.id) {
                return i;
            }
        }
        return 0;
    }

    getAction(): number {
        return this._state.getAction();
    }

    getActionEntityType(): number | null {
        if (this._state.getAction() === ActionStateEnum.AddEntity ||
            this._state.getAction() === ActionStateEnum.EditEntity ||
            this._state.getAction() === ActionStateEnum.EditEntities) {
            return (this._state as unknown as AddEntityState | EditEntityState | EditEntitiesState).getEntityType();
        }
        return null;
    }

    get state(): ActionState {
        return this._state;
    }
    get showDimension(): boolean {
        return this._showDimension;
    }
    set showDimension(value: boolean) {
        this._showDimension = value;
    }
    get opacity(): number {
        return this._opacity.value;
    }
    set opacity(value: number) {
        if (value < this._opacity.min) {
            value = this._opacity.min;
        }
        if (value > this._opacity.max) {
            value = this._opacity.max;
        }
        this._opacity.value = value;
        GameObjectManager.updateOpacity(this._opacity.value);

        SavaneCookie.setCookie("Rhinov-CocosPlan-BackgroundOpacity", "" + this._opacity.value);
        //eventsManager.instance.dispatch(Events.TOGGLE_HIGHLIGHT_MODE, value);
    }
    get vectorDraw(): boolean {
        if (this._vectorDraw === 1) {
            return (true);
        }
        else {
            return (false);
        }
    }
    set vectorDraw(value: boolean) {
        if (value) {
            this._vectorDraw = 1;
        }
        else {
            this._vectorDraw = 0;
        }
        SavaneCookie.setCookie("Rhinov-CocosPlan-VectorDraw", "" + this._vectorDraw);
    }
    get opacityFloors(): number {
        return this._opacityFloors.value;
    }
    set opacityFloors(value: number) {
        if (value < this._opacityFloors.min) {
            value = this._opacityFloors.min;
        }
        if (value > this._opacityFloors.max) {
            value = this._opacityFloors.max;
        }
        this._opacityFloors.value = value;

        SavaneCookie.setCookie("Rhinov-CocosPlan-FloorOpacity", "" + this._opacityFloors.value);

        //eventsManager.instance.dispatch(Events.TOGGLE_HIGHLIGHT_MODE, value);
    }
    get selection(): Entity[] {
        return this.selectedEntities;
    }
    changeThicknessTool(event: Event) {
        var thickness = event.getUserData().thickness;
        if (thickness < event.getUserData().min) {
            thickness = event.getUserData().min;
        }
        if (thickness > event.getUserData().max) {
            thickness = event.getUserData().max;
        }
        EntityDefaultPropertiesManager.getInstance().setCurrentToolParams(thickness);
    }
    /**
     **********WARNING**********
     * Changing state should only be done from the current state, this method is used to set the first state
     * Never use it in an other purpose to avoid unwanted state change
     *
     * @param stateId
     */
    changeState(stateId: number) {
        var newState = null;

        // Par défaut ne jamais afficher le soleil
        this.showSun = false;

        //Dispose previous state
        if (this._state.getAction() === ActionStateEnum.FrontView) {
            this.switchToNormalMode(stateId === ActionStateEnum.IdleConstruction);
        }
        else {
            this._state.dispose();
        }

        switch (stateId) {
            case ActionStateEnum.idleCamera:
                newState = new IdleCameraState();
                newState.lockViewNoOffset();
                break;
            case ActionStateEnum.RoomsValidation:
                newState = new RoomsValidationState();
                newState.lockViewNoOffset();
                break;
            case ActionStateEnum.SelectedOrderRoom:
                newState = new SelectedOrderRoom();
                newState.lockViewNoOffset();
                break;
            case ActionStateEnum.AbsoluteIdle:
                newState = new AbsoluteIdleState();
                newState.lockViewNoOffset();
                break;
            case ActionStateEnum.Quotation:
                newState = new QuotationState();
                newState.lockViewNoOffset();
                break;
            case ActionStateEnum.IdleConstruction:
                newState = new IdleConstruction();
                break;
            case ActionStateEnum.idleDecoration:
                // En idleDecoration, afficher le soleil (seulement en idleDecoration)
                this.showSun = true;
                newState = new IdleDecoration();
                break;
            // case ActionStateEnum.idleSmartDesigner:
            //     newState = new IdleSmartDesignerState();
            //     break;
            case ActionStateEnum.DrawWorkTop:
                newState = new WorkTopState();
                break;
            case ActionStateEnum.DrawArea:
                newState = new AreaState(null as any, null as any);
                break;
            default://Default will set to visualize
            case ActionStateEnum.idleVisualise:
                newState = new IdleVisualiseState();
                newState.lockViewNoOffset();
                break;

        }
        PlanManager.getInstance().updateItemsSelected(null);
        this._state = newState as ActionState;
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, this.getAction());
    }
    convertToMMCoord(point: math.vec3) {
        point[0] = Math.round(point[0]) * 10;
        point[1] = Math.round(point[1]) * 10;
    }
    switchToEdition() {
        this._state.dispose();
        this._state = new IdleConstruction() as unknown as ActionState;
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, this.getAction());
        this.scrollWindow.rebuildGrid(undefined as any);

    }

    mouseIdle(position: math.vec3, dt: number) {
        var pos = this.scrollWindow.grid.convertToNodeSpace(new cc.p(position[0], position[1]));
        var planPos = math.vec3.create();
        math.vec3.set(planPos, pos.x, pos.y, 0);
        this.convertToMMCoord(planPos);

        //this._uiState.cursorPosition = planPos;
        //console.log('PlanManager.mouseIdle: ', planPos[0], planPos[1]);

        this._state.mouseIdle(planPos, this._uiState.hoverEntities, dt);
    }

    mouseClickDown(position: math.vec3, doubleClick: boolean, mouseButton: number) {
        if (this.world) {
            this.world.timerTick(this._state.isDecorationState() ? 2 : 1, this._isCR, this._isVisioDesignerCR);
        }
        $('#uibMovable>.dropdown-menu').css('display', 'none');
        // Close contextul menu
        $('#ContextualMenuRoom').css('display', 'none');
        $('#ContextualMenuGeoPrim').css('display', 'none');
        if (mouseButton !== cc.EventMouse.BUTTON_MIDDLE) {
            var state = this._state.mouseClickDown(this._uiState.cursorPosition, doubleClick, this._uiState.hoverEntities, mouseButton);
            if (state) {
                this._state.dispose();
                this._state = state;
                eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED);
            }
        } else {
            var posx = this._uiState.cursorPosition[0] / 10;
            var posy = this._uiState.cursorPosition[1] / 10;
            this.scrollWindow._startDragging(posx, posy, true);
        }
    }

    mouseClickUp(position: math.vec3, elapsedTime: number) {
        if (this.mouseButton === cc.EventMouse.BUTTON_MIDDLE) {
            var posx = this._uiState.cursorPosition[0] / 10;
            var posy = this._uiState.cursorPosition[1] / 10;
            this.scrollWindow._endDragging(posx, posy, true);
        } else {
            var cursorPosition = this._uiState.cursorPosition;

            if ((this.state instanceof EditEntityState) || (this.state instanceof EditEntitiesState)) {
                cursorPosition = this._uiState.unsnappedCursorPosition;
            }

            var state = this._state.mouseClickUp(cursorPosition, elapsedTime, this._uiState.hoverEntities, this.mouseButton!);

            if (state === null && elapsedTime < Utils.TOUCH_SNAP_TIME) {
                //Very short click
                state = this._state.snapClick();

            }
            if (state) {
                this._state.dispose();
                this._state = state;
                eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED);

                if (elapsedTime < Utils.TOUCH_SNAP_TIME) {
                    eventsManager.instance.dispatch(Events.CANCEL_CLICK);
                }
            }
        }

        this.mouseButton = null;
        this.scrollWindow.stopAutoDragging();
    }

    mouseClickCancelled(position?: math.vec3) : ActionState | null {
        var state = this._state.mouseClickCancelled(this._uiState.cursorPosition);
        if (state) {
            this._state.dispose();
            this._state = state;
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED);
            eventsManager.instance.dispatch(Events.CANCEL_CLICK);
        }

        return state;
    }
    moveMouseCursor(position: math.vec3) {
        var planPos = null;
        if (this.scrollWindow.isVisible()) {
            var pos = this.scrollWindow.grid.convertToNodeSpace(position);
            planPos = math.vec3.create();
            math.vec3.set(planPos, pos.x, pos.y, 0);
            this.convertToMMCoord(planPos);
        } else {
            //already convert
            planPos = position;
        }

        var uiState = this._uiState.moveMouseCursor(planPos, position);
        if (uiState) {
            this._uiState = uiState;
        }
        //Provoke drag
        if (this.mouseButton === cc.EventMouse.BUTTON_MIDDLE) {
            //Only drag
            var posx = this._uiState.cursorPosition[0] / 10;
            var posy = this._uiState.cursorPosition[1] / 10;
            this.scrollWindow._mouseDragging(posx, posy, true);
        } else if (this.mouseButton === cc.EventMouse.BUTTON_LEFT || this.mouseButton === null) {
            var state = this._state.moveMouseCursor(this._uiState.cursorPosition, this._uiState.hoverEntities, planPos);
            if (state) {
                this._state.dispose();
                this._state = state;
            }
        }
    }

    keyUnPressed(keyCode: number) {
        this._uiState.keyUnPressed(keyCode);
        var state = this._state.keyUnPressed(keyCode);
        if (state) {
            this._state.dispose();
            this._state = state;
        }
        eventsManager.instance.dispatch(Events.START_UPDATING_ENVS);
    }
    /**
     * A key is pressed
     *
     * @param keyCode
     * @param ctrl
     */
    keyPressed(keyCode: number, isCtrl: boolean) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        this._uiState.keyPressed(keyCode);
        var state = this._state.keyPressed(keyCode, isCtrl);
        if (state === null && (keyCode === cc.KEY.escape || keyCode === cc.KEY.backspace)) {
            //Same effect than a short click
            state = this._state.snapClick();
        }

        if (keyCode === cc.KEY.q) {
            var value = parseInt(SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0));

            if (value === 0) {
                SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 1);
            }
            else {
                SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0);
            }
            eventsManager.instance.dispatch(Events.ENABLE_OBJECT_FILTERS_CHANGED, {forceUpdate: true});
        }

        if (keyCode === cc.KEY.a) {
            this.magnetRotation = !this.magnetRotation;
        }

        if (state) {
            this._state.dispose();
            this._state = state;
        }
    }

    updateCurrentRoomMainFunctionality(event: Event): boolean {
        var data = event.getUserData().data;

        if (this.selectedEntities.length === 1 && this.selectedEntities[0] instanceof Room) {
            var room = this.selectedEntities[0];
            //Retrieve list of secondary func
            var functionalityChips = room.functionalityChips;

            for (var i = 0; i < functionalityChips.length; i++) {
                GameObjectManager.deleteFunctionalityChip(functionalityChips[i]);
            }
            room.startTemporary();
            if (room.setPrimaryFunctionality(data.id, data.name)) {
                //Update room node
                var drawnode = EntityManager.getInstance().getNode(room)!;
                drawnode.updateName();

                if (this.debounceChangeRoomFunctionality) {
                    clearTimeout(this.debounceChangeRoomFunctionality);
                    this.debounceChangeRoomFunctionality = null;
                }

                this.debounceChangeRoomFunctionality = setTimeout(() => {
                    let command = new Commands.EditRoomPropertiesCommand(room);
                    command.functionnalityChangeCallback = (modifiedRoom, command) => {
                        // If the room doesn't need plinths
                        if (modifiedRoom.doesntNeedPlinth()) {
                            // Deactivate plinths
                            modifiedRoom.hasPlinths = false;
                        }
        
                        //Do we have to modify the wall height for this new room type ?
                        var modifyWallHeight = false;
                        var newWallHeight: number = 0;
        
                        // Room with no ceiling, decrease the walls to 0mm height
                        if (modifiedRoom.doesntNeedCeiling()) {
                            var functionalityComponent = modifiedRoom.getComponent(ComponentConstants.ComponentType.Functionality) as Functionality;
        
                            if (functionalityComponent !== null && functionalityComponent.functionalityId !== ComponentConstants.Functionalities.Patio) {
                                modifyWallHeight = true;
                                newWallHeight = 0;
                                // Set the room height to 0 too
                                modifiedRoom.height = 0;
                            }
                        }
        
                        // Room with small walls (balcony), reduce the walls to 1000mm
                        if (modifiedRoom.needsSmallWalls()) {
                            modifyWallHeight = true;
                            newWallHeight = 1000;
                        }
        
                        if (modifiedRoom.isPool) {
                            modifiedRoom.height = 1500;
                            modifyWallHeight = true;
                            newWallHeight = 1500;
                        }

                        // If we have to adjust wall height due to new room functionnality
                        if (modifyWallHeight) {
                            // Parse all room walls
                            for (var i = 0; i < room.walls.length; i++) {
                                var wall = room.walls[i];
        
                                if (wall.isSpecialWall) {
                                    continue;
                                }
        
                                // If the wall belongs only to this room, then set its height to 0
                                if (wall.rooms.length === 1) {
                                    if (wall.children.length === 0) {
                                        wall.startTemporary();
                                        wall.height = newWallHeight;
                                        command.subCommands.push(new Commands.EditWallPropertiesCommand(wall));
                                    }
                                }
                                else {
                                    // Wall belongs to more than one room, check all rooms if they all don't need ceiling
                                    var doModify = true;
        
                                    // Parse all rooms around the wall
                                    for (var j = 0; j < wall.rooms.length; j++) {
                                        var otherRoom = wall.rooms[j];
        
                                        // Forget the room we are currently changing the functionnality of
                                        if (otherRoom.id !== room.id) {
                                            // If one of then needs a ceiling, then we don't modify the wall
                                            if (!otherRoom.doesntNeedCeiling()) {
                                                doModify = false;
                                                break;
                                            }
                                        }
                                    }
        
                                    // If the wall height can be set to 0 (all rooms around don't need ceilings)
                                    if (doModify) {
                                        if (wall.children.length === 0) {
                                            wall.startTemporary();
                                            wall.height = newWallHeight;
                                            command.subCommands.push(new Commands.EditWallPropertiesCommand(wall));
                                        }
                                    }
                                }
        
                                var drawnode = EntityManager.getInstance().getNode(wall);
                                if (drawnode) {
                                    drawnode.needRedraw = true;
                                    drawnode.update();
                                }
                            }
                        }
                    };

                    eventsManager.instance.dispatch(Events.UPDATE_MAINFUNCTIONALITY_CHANGE_NODE, data);
                    this.setFunctionalitesActionCount(this.functionalitiesAction + 1);
                    PlanManager.getInstance().executeCommand(command);
                }, event.getUserData().debounce);
            } else {
                room.endTemporary();
            }
        }
        return false;
    }

    areRulersActive() : boolean{
        return this._areRulersActive;
    }

    setRulersActive(bool: boolean) {
        this._areRulersActive = bool;
    }
    /**
     * Need to have forced to true or current user specify that he need cache saving
     * @param forced
     */
    saveInCache(forced?: boolean) {
        if (this.autoCache || forced) {
            var jsonProject = {
                'deliverableID': this.deliverableID,
                'rhinov_format': JSONSerializer.serializeEntity(this.world)
            };
            Utils.saveLocal(CocosConstants.autosaveCookieName, JSON.stringify(jsonProject));
        }
    }

    executeCommand(command: Command) {
        if (this._lastIndexActionDone[this._currentFloorId] === undefined || this._lastActions[this._currentFloorId] === undefined) {
            this._lastIndexActionDone[this._currentFloorId] = -1;
            this._lastActions[this._currentFloorId] = [];
        }

        if (this._lastIndexActionDone[this._currentFloorId] !== -1) {
            this._lastActions[this._currentFloorId].splice(this._lastIndexActionDone[this._currentFloorId] + 1, this._lastActions[this._currentFloorId].length - this._lastIndexActionDone[this._currentFloorId] - 1);
        }
        this._lastIndexActionDone[this._currentFloorId]++;
        this._lastActions[this._currentFloorId][this._lastIndexActionDone[this._currentFloorId]] = command;
        command.execute();
        this.setActionCount(this._actionCount + 1);
        this.handleFurniture(command);
        this.saveInCache();

        // If the command provokes a need to refresh the hull, do it now
        if (command.needsRefreshHull()) {
            eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
        }
    }

    joineryColorCommand(event: Event) {
        var color = event.userData.color;
        var indoor = event.userData.indoor;

        var joineries = PlanManager.getInstance().world.currentScene!.joineries;
        for (var i = 0; i < joineries.length; i++) {
            var joinery = joineries[i];

            if (joinery.parent) {
                if ((joinery.parent as Wall).rooms.length === 1 && !indoor) {
                    joinery.materialType = parseInt(color);
                }

                if ((joinery.parent as Wall).rooms.length === 2) {

                    if ((joinery.parent as Wall).rooms[0].isExterior || (joinery.parent as Wall).rooms[1].isExterior && !indoor) {
                        joinery.materialType = parseInt(color);
                    }
                    else {
                        if (indoor) {
                            joinery.materialType = parseInt(color);
                        }
                    }
                }
            }
        }
        this.saveInCache();
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Go! button for project translation
    translationCommand(event: Event) {
        // Do not generate a command if no translation requested (i.e. requested translation = 0 for X and Y)
        if (event.userData.translateX !== 0 || event.userData.translateY !== 0) {
            PlanManager.getInstance().executeCommand(new Commands.TranslateProjectCommand(event.userData.translateX, event.userData.translateY, PlanManager.getInstance().world.currentScene!));
            eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
        }
    }

    // Called by either H-Symetry and V-Symetry button
    symetryCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SymetryProjectCommand(event.userData, PlanManager.getInstance().world.currentScene!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Go! button for project rotation
    rotationCommand(event: Event) {
        // Do not generate command if no rotation requested (i.e. rotation angle = 0)
        if (event.userData !== 0) {
            PlanManager.getInstance().executeCommand(new Commands.RotateProjectCommand(event.userData, PlanManager.getInstance().world.currentScene!));
            eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
        }
    }

    // Called by the Go! button for project scale
    scaleCommand(event: Event) {
        // DO not generate command if no scale request (i.e. is factor = 100% then no scale)
        if (event.userData !== 100) {
            PlanManager.getInstance().executeCommand(new Commands.ScaleProjectCommand(Math.abs(event.userData / 100), PlanManager.getInstance().world.currentScene!));
            eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
        }
    }

    // Called by the Etage courant button for set current floor height
    setFloorHeightCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SetFloorHeightCommand(Math.abs(event.userData), PlanManager.getInstance().world.currentScene!.currentFloor!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Tout le projet button for set project floor height
    setProjectFloorHeightCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SetProjectFloorHeightCommand(Math.abs(event.userData), PlanManager.getInstance().world.currentScene!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Go button to set the rooms current floor height
    setRoomFloorHeightCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SetRoomFloorHeightCommand(event.userData, PlanManager.getInstance().world.currentScene!.currentFloor!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Activer/Désactiver étage for cornices
    setFloorCornicesCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SetFloorCornicesCommand(event.userData, PlanManager.getInstance().world.currentScene!.currentFloor!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    // Called by the Activer/Désactiver projet for cornices
    setProjectCornicesCommand(event: Event) {
        PlanManager.getInstance().executeCommand(new Commands.SetProjectCornicesCommand(event.userData, PlanManager.getInstance().world.currentScene!));
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
    }

    redoCommand() {
        var command = null;

        if (this._lastIndexActionDone[this._currentFloorId] !== -1 &&
            (this.state.getAction() === ActionStateEnum.IdleConstruction || this.state.getAction() === ActionStateEnum.idleCreate ||
            this.state.getAction() === ActionStateEnum.idleDecoration || this.state.getAction() === ActionStateEnum.DrawWorkTop ||
            this.state.getAction() === ActionStateEnum.FrontViewCoating ||
            (this.state.getAction() === ActionStateEnum.addRoom && !(this.state as unknown as AddRoomState).isRoomCreated) ||
            (this.state.getAction() === ActionStateEnum.FrontView && !(this.state as unknown as FrontViewState).isUpdating))) {
            if (this._lastIndexActionDone[this._currentFloorId] < this._lastActions[this._currentFloorId].length - 1) {
                this._lastIndexActionDone[this._currentFloorId]++;

                command = this._lastActions[this._currentFloorId][this._lastIndexActionDone[this._currentFloorId]];
                if (command) {
                    command.execute();
                }
                this.setActionCount(this._actionCount + 1);
            }
        }
        else if (this._lastActions[this._currentFloorId].length !== 0) {
            this._lastIndexActionDone[this._currentFloorId] = 0;

            command = this._lastActions[this._currentFloorId][this._lastIndexActionDone[this._currentFloorId]];
            if (command) {
                command.execute();
            }
            this.setActionCount(this._actionCount + 1);
        }

        // If the command provokes a need to refresh the hull, do it now
        if (command !== null) {
            this.handleFurniture(command);
            if (command.needsRefreshHull()) {
                eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
            }
        }

        this.saveInCache();
    }

    undoCommand() {
        if (this._lastIndexActionDone[this._currentFloorId] !== -1 &&
            (this.state.getAction() === ActionStateEnum.IdleConstruction || this.state.getAction() === ActionStateEnum.idleCreate ||
            this.state.getAction() === ActionStateEnum.idleDecoration || this.state.getAction() === ActionStateEnum.DrawWorkTop ||
            this.state.getAction() === ActionStateEnum.FrontViewCoating ||
            (this.state.getAction() === ActionStateEnum.addRoom && !(this.state as unknown as AddRoomState).isRoomCreated) ||
            (this.state.getAction() === ActionStateEnum.FrontView && !(this.state as unknown as FrontViewState).isUpdating))) {

            PlanManager.getInstance().updateItemsSelected(null);

            // Get command to undo
            var command = this._lastActions[this._currentFloorId][this._lastIndexActionDone[this._currentFloorId]];
            if (command) {
                // Undo it
                command.undo();
            }

            this._lastIndexActionDone[this._currentFloorId]--;
            this.setActionCount(this._actionCount - 1);

            if (command) {
                this.handleFurniture(command);

                // If the command provokes a need to refresh the hull, do it now
                if (command.needsRefreshHull()) {
                    eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
                }
            }
        }

        this.saveInCache();
    }
    setActionCount(nb: number) {
        this._actionCount = nb;
        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE, this._actionCount + this.functionalitiesAction === 0);
        /*var scope = angular.element($('#saveProject')).scope();
         scope.safeApply(function () {
         scope.disableSaveProject = this._actionCount + this.functionalitiesAction === 0;
         }.bind(this));*/
    }
    setFunctionalitesActionCount(nb: number) {
        this.functionalitiesAction = nb;
        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE, this._actionCount + this.functionalitiesAction === 0);
        /*var scope = angular.element($('#saveProject')).scope();
         scope.safeApply(function () {
         scope.disableSaveProject = this._actionCount + this.functionalitiesAction === 0;
         }.bind(this));*/
    }
    getActionCountSinceLastSave(): number {
        return this._actionCount + this.functionalitiesAction;
    }

    /**
     * A button has been pressed in the LeftPanel
     * @param buttonId
     */
    duplicateElement(items: Entity[]): boolean {
        PlanManager.getInstance().updateItemsSelected(null);
        var newState = null;

        var cloned = [];
        var newEntities: Array<Entity> = [];
        for (var i = 0; i < items.length; ++i) {
            var item = items[i];
            if (item instanceof Joinery) {
                var newJoinery: Joinery = EntityFactory.getInstance().cloneEntity(item, true) as Joinery;
                if (this.frontViewLayer.isVisible()) {
                    var pos = math.vec3.create();
                    math.vec3.set(pos, newJoinery.position[0], newJoinery.position[1], newJoinery.position[2]);
                    this.frontViewLayer.currentWall?.addChild(newJoinery);
                    newJoinery.position = pos;

                    newState = new FrontViewAddJoinery(newJoinery);
                }
                else {
                    if (item.wall && item.wall.rooms.length > 0) {
                        var maxRoomFloorHeight = Number.NEGATIVE_INFINITY;
                        for (var i = 0 ; i < item.wall.rooms.length ; ++i) {
                            maxRoomFloorHeight = Math.max(maxRoomFloorHeight, item.wall.rooms[i].floorHeight);
                        }

                        newJoinery.floorHeight -= maxRoomFloorHeight;
                    }
                    newState = new AddJoineryState(newJoinery);
                }
                break;
            }
            if (item.entityType === SceneConstants.EntityType.Staircase ||
                item.entityType === SceneConstants.EntityType.TechnicalElement ||
                item.entityType === SceneConstants.EntityType.GeometryPrimitive ||
                item.entityType === SceneConstants.EntityType.ArrangementObject ||
                item.entityType === SceneConstants.EntityType.ArrangementGroup ||
                item.entityType === SceneConstants.EntityType.RenderCamera ||
                item.entityType === SceneConstants.EntityType.Comment) {
                var newEntity = EntityFactory.getInstance().cloneEntity(item, true)!;

                // Post update for cameras to renumber it correctly
                if (item.entityType === SceneConstants.EntityType.RenderCamera) {
                    (newEntity as RenderCamera).cameraNb = 0;
                    (newEntity as RenderCamera).updateCameraNb(PlanManager.getInstance().world);
                }
                cloned.push({ entity: newEntity, parent: item.parent });
                newEntities.push(newEntity);
            }
        }

        if (cloned.length > 0) {
            if (this.frontViewLayer.isVisible()) {
                var newEntity = EntityFactory.getInstance().cloneEntity(newEntities[0], true)!;
                newState = new FrontViewAddEntity(newEntity);
            }
            else {
                this.executeCommand(new Commands.AddEntitiesCommand(cloned, true, undefined as any, undefined as any));

                if (newEntities.length === 1) {
                    newState = new EditEntityState(newEntities[0], this._uiState.unsnappedCursorPosition);
                } else {
                    newState = new EditEntitiesState(newEntities, this._uiState.unsnappedCursorPosition);
                }
            }
        }
        if (newState) {
            this._state.dispose();
            this._state = newState as unknown as ActionState;
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, this.getAction());
            return true;
        } else {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, this.getAction());
            return false;
        }
    }

    onRenderCamera(asset: string) {
        console.log(asset);
    }

    addWall(wall: Wall, tryCreateRoom: boolean): Room[] | null {
        if (tryCreateRoom === null || tryCreateRoom === undefined) {
            tryCreateRoom = true;
        }

        EntityManager.getInstance().deleteNodeAndChild(wall);
        for (var i = 0; i < wall.rooms.length; ++i) {
            EntityManager.getInstance().deleteNodeAndChild(wall.rooms[i]);
        }

        var affectedRooms = this.world.currentScene!.addWall(wall, tryCreateRoom, EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.height);
        var itemToRecompute = [];
        if (affectedRooms !== null) {
            for (var i = 0; i < affectedRooms.length; ++i) {
                for (var k = 0; k < affectedRooms[i].children.length; ++k) {
                    itemToRecompute.push(affectedRooms[i].children[k]);
                }
            }
        }

        if (affectedRooms) {
            for (var i = 0; i < affectedRooms.length; ++i) {
                EntityManager.getInstance().deleteNodeAndChild(affectedRooms[i]);
            }

            for (var i = 0; i < affectedRooms.length; ++i) {
                if (affectedRooms[i].parent) {
                    GameObjectManager.updateRooms([affectedRooms[i]]);
                }
            }
        }

        GameObjectManager.drawWall(wall, true, false, false);

        //Recompute all items
        for (var i = 0; i < itemToRecompute.length; ++i) {
            var item = itemToRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area) as any;
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                }
                else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
        return affectedRooms;
    }
    deleteWall(id: number, tryCreateRoom?: boolean): Room[] | null {
        if (tryCreateRoom === null || tryCreateRoom === undefined) {
            tryCreateRoom = true;
        }
        //Retrieve wall framework entity
        var wall = PlanManager.getInstance().world.currentScene!.currentFloor!.getWall(id);

        if (wall === null) {
            return null;
        }

        //Remove graphical node even for unprocessed wall
        EntityManager.getInstance().deleteNodeAndChild(wall);
        for (var i = 0; i < wall.rooms.length; ++i) {
            EntityManager.getInstance().deleteNodeAndChild(wall.rooms[i]);
        }

        var rooms = [];
        var itemToRecompute = [];
        for (var i = 0; i < wall.rooms.length; i++) {
            rooms.push(wall.rooms[i]);
            for (var k = 0; k < wall.rooms[i].children.length; k++) {
                itemToRecompute.push(wall.rooms[i].children[k]);
            }
        }
        //Remove from framework and update display
        var roomsToUpdate = this.world.currentScene!.deleteWall(id, tryCreateRoom);
        GameObjectManager.updateRooms(roomsToUpdate);
        for (var i = 0; i < this.selectedEntities.length; i++) {
            if (this.selectedEntities[i].id === id && this.selectedEntities[i].isWallEntity()) {
                this.selectedEntities.splice(i, 1);
                break;
            }
        }

        //Recompute all items
        for (var i = 0; i < itemToRecompute.length; i++) {
            var item = itemToRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area) as any;
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                } else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
        return roomsToUpdate;
    }
    /**
     * Process the cut of a wall and keep room data using cloning
     * @param wall          The wall to be cutted
     * @param cuttedWalls   The two wall that will replace the wall
     */
    cutWall(wall: Wall, cuttedWalls: Wall[]) {
        var i, j;
        //Store wall rooms :
        var rooms = [];
        var itemToRecompute = [];
        //FIXME wall.rooms is undefined and length can't be retrieved
        for (i = 0; i < wall.rooms.length; i++) {
            rooms.push({
                room: EntityFactory.getInstance().cloneRoom(wall.rooms[i], false, undefined as any),
                side: wall.rooms[i].wallOrientationInRoom(wall, undefined as any)
            });
            for (j = 0; j < wall.rooms[i].walls.length; j++) {
                rooms[i].room.addWall(wall.rooms[i].walls[j]);
            }
            for (var k = 0; k < wall.rooms[i].children.length; k++) {
                itemToRecompute.push(wall.rooms[i].children[k]);
            }
        }
        this.deleteWall(wall.id, false);
        for (i = 0; i < cuttedWalls.length; i++) {
            this.addWall(cuttedWalls[i], false);
        }
        for (i = 0; i < rooms.length; i++) {
            var idRemoved = rooms[i].room.deleteWall(wall.id);
            if (idRemoved >= (rooms[i].room as any)._walls.length) {
                if (!rooms[i].side) {
                    for (j = cuttedWalls.length - 1; j >= 0; j--) {
                        rooms[i].room.addWall(cuttedWalls[j]);
                    }
                } else {
                    for (j = 0; j < cuttedWalls.length; j++) {
                        rooms[i].room.addWall(cuttedWalls[j]);
                    }
                }
            } else {
                if (!rooms[i].side) {
                    for (j = 0; j < cuttedWalls.length; j++) {
                        rooms[i].room.addWallAtIndex(cuttedWalls[j], idRemoved);
                    }
                } else {
                    for (j = cuttedWalls.length - 1; j >= 0; j--) {
                        rooms[i].room.addWallAtIndex(cuttedWalls[j], idRemoved);
                    }
                }
            }

            PlanManager.getInstance().world.currentScene!.currentFloor!.addRoom(rooms[i].room);
            roomManager.manageNonRoomedWalls(PlanManager.getInstance().world.currentScene!.currentFloor!);
            GameObjectManager.drawRoom(rooms[i].room, undefined);
        }
        //Recompute all items
        for (i = 0; i < itemToRecompute.length; i++) {
            var item = itemToRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area) as any;
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                } else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
    }
    /**
     * Process the merge of a walls and keep room data using cloning
     * @param wall       The wall that replace the previous walls
     * @param mergedWall    The list of merged walls
     */
    mergeWalls(wall: Wall, mergedWalls: Wall[]) {
        var i, j;
        //Store wall rooms :
        var rooms = [];
        var itemToRecompute = [];
        for (i = 0; i < mergedWalls[0].rooms.length; i++) {
            rooms.push({
                room: EntityFactory.getInstance().cloneRoom(mergedWalls[0].rooms[i], false, undefined as any),
                side: mergedWalls[0].rooms[i].wallOrientationInRoom(mergedWalls[0], undefined as any)
            });
            for (var k = 0; k < mergedWalls[0].rooms[i].children.length; k++) {
                itemToRecompute.push(mergedWalls[0].rooms[i].children[k]);
            }
            for (j = 0; j < mergedWalls[0].rooms[i].walls.length; j++) {
                rooms[i].room.addWall(mergedWalls[0].rooms[i].walls[j]);
            }
        }
        for (i = 0; i < mergedWalls.length; i++) {
            this.deleteWall(mergedWalls[i].id, rooms.length === 0);
        }
        this.addWall(wall, false);
        for (i = 0; i < rooms.length; i++) {
            for (j = 1; j < mergedWalls.length; j++) {
                rooms[i].room.deleteWall(mergedWalls[j].id);
            }
            var idRemoved = rooms[i].room.deleteWall(mergedWalls[0].id);
            if (idRemoved >= (rooms[i].room as any)._walls.length) {
                rooms[i].room.addWall(wall);
            } else {
                rooms[i].room.addWallAtIndex(wall, idRemoved);
            }

            EntityManager.getInstance().deleteNodeAndChild(rooms[i].room);
            PlanManager.getInstance().world.currentScene!.currentFloor!.addRoom(rooms[i].room);
            roomManager.manageNonRoomedWalls(PlanManager.getInstance().world.currentScene!.currentFloor!);
            GameObjectManager.drawRoom(rooms[i].room);
        }
        //Recompute all items
        for (i = 0; i < itemToRecompute.length; i++) {
            var item = itemToRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area) as any;
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                } else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
    }
    addJoinery(joinery: Joinery) {
        EntityManager.getInstance().addEntity(joinery);
        joinery.wall.addJoinery(joinery);
    }
    deleteJoinery(id: number) {
        var joinery = joineryManager.getJoinery(id, PlanManager.getInstance().world.currentScene!);
        if (!joinery) {
            return;
        }
        EntityManager.getInstance().removeEntity(joinery);
        if (joinery.wall) {
            joinery.wall.deleteJoinery(id);
        }

        for (var i = 0; i < this.selectedEntities.length; i++) {
            if (this.selectedEntities[i].id === id && this.selectedEntities[i].isJoineryEntity()) {
                this.selectedEntities.splice(i, 1);
                break;
            }
        }
    }

    addTechnicalElement(technicalElement: TechnicalElement) {
        EntityManager.getInstance().createNode(technicalElement);
        this.world.currentScene!.addTechnicalElement(technicalElement);
    }

    addGeometryPrimitive(geomPrimElement: GeometryPrimitive) {
        EntityManager.getInstance().createNode(geomPrimElement);
        this.world.currentScene!.addGeometryPrimitive(geomPrimElement);
    }

    deleteTechnicalElement(id: number) {
        var i;
        EntityManager.getInstance().deleteNode(id);
        this.world.currentScene!.deleteTechnicalElement(id);
        for (i = 0; i < this.selectedEntities.length; i++) {
            if (this.selectedEntities[i].id === id && this.selectedEntities[i].isTechnicalElementEntity()) {
                this.selectedEntities.splice(i, 1);
                break;
            }
        }
    }
    addStaircase(stair: Staircase) {
        EntityManager.getInstance().createNode(stair);
        this.world.currentScene!.addStaircase(stair);
    }
    deleteStaircase(id: number) {
        var i;
        EntityManager.getInstance().deleteNode(id);
        this.world.currentScene!.deleteStaircase(id);

        for (i = 0; i < this.selectedEntities.length; i++) {
            if (this.selectedEntities[i].id === id && this.selectedEntities[i].isStaircaseEntity()) {
                this.selectedEntities.splice(i, 1);
                break;
            }
        }
    }

    selectAll() {
        if (PlanManager.getInstance().getAction() === ActionStateEnum.IdleConstruction) {
            this.updateItemsSelected(PlanManager.getInstance().world.currentScene!.currentFloor!.walls, true, false);
        }

        if (PlanManager.getInstance().getAction() === ActionStateEnum.idleDecoration) {
            this.updateItemsSelected(PlanManager.getInstance().world.currentScene!.currentFloor!.arrangementObjectsAndGroups, true, false);
        }
    }

    updateItemsSelected(entities: Entity[] | null, keepSelected?: boolean, showTulip?: boolean) {
        var i, j;
        var oldSelectedEntities = this.selectedEntities[0];
        if (oldSelectedEntities !== undefined && oldSelectedEntities !== null) {
            //Save last entity (to use as a copy, only save duplicable)
            if (oldSelectedEntities.entityType === SceneConstants.EntityType.Staircase ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.TechnicalElement ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.GeometryPrimitive ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.GeometryGroup ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.Joinery ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.ArrangementObject ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.ArrangementGroup ||
                oldSelectedEntities.entityType === SceneConstants.EntityType.Comment) {
                this.lastSelected = oldSelectedEntities;
            }
        }
        GameObjectManager.unselectItems(this.selectedEntities);
        if (showTulip === undefined) {
            showTulip = true;
        }

        if (entities !== null && entities.length > 0) {
            if (keepSelected && this.selectedEntities !== null &&
                this.selectedEntities.length > 0 &&
                this.selectedEntities[0].entityType === entities[0].entityType) {
                for (i = 0; i < entities.length; i++) {
                    var toAdd = true;
                    for (j = 0; j < this.selectedEntities.length; j++) {
                        if (entities[i].id === this.selectedEntities[j].id) {
                            toAdd = false;
                        }
                    }
                    if (toAdd) {
                        this.selectedEntities.push(entities[i]);
                    }
                }
            } else {
                this.selectedEntities = (entities ? entities.slice() : []);
            }
            if (entities[0].isArrangementObjectEntity()) {
                eventsManager.instance.dispatch(Events.SET_FILTERS, {
                    entity: entities[0]
                });
            }
        } else if (!keepSelected) {
            this.selectedEntities = (entities ? entities.slice() : []);
        }
        if (this.selectedEntities !== null && this.selectedEntities.length > 0) {
            for (i = 0; i < this.selectedEntities.length; i++) {
                if (this.selectedEntities[i].isWallEntity()) {
                    var wallNode = EntityManager.getInstance().getNode(this.selectedEntities[i]);
                    if (wallNode != null) {
                        wallNode.exitMovable();
                    }
                }
            }
        }

        if (!showTulip) {
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }
        else {
            if (this.selectedEntities.length > 0) {
                if (this.selectedEntities.length === 1) {
                    var dn = EntityManager.getInstance().getNode(this.selectedEntities[0]);
                    if (this.selectedEntities[0].entityType === SceneConstants.EntityType.UserPicture) {
                        eventsManager.instance.dispatch(Events.SHOW_TULIP, {
                            TypeProperties: this.selectedEntities[0].entityType,
                            obj: this.selectedEntities[0],
                            camera: this.selectedEntities[0],
                            edit: true,
                            cocosData: dn
                        });
                    }
                    else {
                        eventsManager.instance.dispatch(Events.SHOW_TULIP, {
                            TypeProperties: this.selectedEntities[0].entityType,
                            obj: this.selectedEntities[0],
                            cocosData: dn
                        });
                    }
                }
                else {
                    var groupableEntities = this.selectedEntities.filter((item) => item.isIArrangementEntity() || item.isIGeometryEntity())
                    if (groupableEntities.length > 1) {
                        eventsManager.instance.dispatch(Events.SHOW_TULIP, {
                            TypeProperties: '*',
                            obj: groupableEntities
                        });
                    }
                }
            }
            else {
                eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
            }
        }

        if (this.selectedEntities.length > 0) {
            var floor = this.selectedEntities[0].floor;
            if (floor && floor.id !== PlanManager.getInstance().world.currentScene!.currentFloor!.id) {
                var selected = this.selectedEntities.slice();
                this.setCurrentFloorByIndex(floor.id, false, true);
                this.selectedEntities = selected;
            }
        }

        GameObjectManager.selectItems(this.selectedEntities);
        eventsManager.instance.dispatch(Events.SELECTION_CHANGED);
    }

    unloadCurrentFloor() {
        this.selectedEntities = [];
        if (PlanManager.getInstance().world && PlanManager.getInstance().world.currentScene) {
            EntityManager.getInstance().deleteNodeAndChild(PlanManager.getInstance().world.currentScene!.currentFloor!);
        }
    }
    unloadUnderFloor() {
        if (PlanManager.getInstance().world && PlanManager.getInstance().world.currentScene) {
            var floor = planManager.getUnderFloor(PlanManager.getInstance().world.currentScene!.currentFloor!);
            if (floor !== null) {
                EntityManager.getInstance().deleteNodeAndChild(floor);
            }
        }
    }

    loadFloorCurrentFloor() {
        var i;
        this.selectedEntities = [];
        //Import second tree
        EntityManager.getInstance().addEntity(PlanManager.getInstance().world.currentScene!.currentFloor!);

        var newCameras = PlanManager.getInstance().world.currentScene!.currentFloor!.renderCameras;
        for (i = 0; i < newCameras.length; i++) {
            EntityManager.getInstance().addEntity(newCameras[i]);
        }

        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (i = 0; i < rooms.length; ++i) {
            GameObjectManager.drawRoom(rooms[i], false);
        }
    }

    loadUnderFloor() {
        var i;
        var node: EntityNode;
        var floor = planManager.getUnderFloor(PlanManager.getInstance().world.currentScene!.currentFloor!);
        if (floor !== null) {
            node = EntityManager.getInstance().createNode(floor)!;
            node.removeFromParent();
            PlanManager.getInstance().scrollWindow.grid.addChild(node, -1);
            if (floor !== null) {
                var newRoomList = floor.rooms;
                for (i = 0; i < newRoomList.length; i++) {
                    node = EntityManager.getInstance().createNode(newRoomList[i])!;
                    node.roomAreaLabel.setVisible(false);
                    node.roomNameLabel.setVisible(false);
                    node.dynamicZorder = false;//Stop zorder updates
                    node.setLocalZOrder(-1);
                }
                var newWallList = floor.walls;
                for (i = 0; i < newWallList.length; i++) {
                    node = EntityManager.getInstance().createNode(newWallList[i])!;
                    node.dynamicZorder = false;//Stop zorder updates
                    node.setLocalZOrder(-1);
                    //GameObjectManager.drawWall(newWallList[i], true, false, false);
                    // node.calculateNeighboorWallValues(newWallList[i]);
                }

                var newTechElementList = floor.technicalElementArray;
                if (newTechElementList !== null) {
                    for (i = 0; i < newTechElementList.length; i++) {
                        if (newTechElementList[i].isStaircaseEntity()) {
                            node = EntityManager.getInstance().createNode(newTechElementList[i])!;
                            node.dynamicZorder = false;//Stop zorder updates
                            node.setLocalZOrder(-1);
                        }
                    }
                }
            }
        }
    }

    setCurrentFloorByIndex(indexFloor: number, toDelete?: boolean, loadUnder?: boolean) {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction | IdleDecoration | FrontViewState).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction | IdleDecoration | FrontViewState).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        if (toDelete === undefined) {
            toDelete = false;
        }
        if (indexFloor === undefined) {
            indexFloor = this._currentFloorId;
        }
        if (loadUnder === undefined) {
            loadUnder = true;
        }
        this._currentFloorId = indexFloor;
        this.unloadCurrentFloor();
        this.unloadUnderFloor();
        var newFloor = this.world.currentScene!.getFloor(indexFloor);
        if (newFloor) {
            PlanManager.getInstance().world.currentScene!.currentFloor = newFloor;
        }
        // @aurelien WIP
        this.loadFloorCurrentFloor();
        if (loadUnder) {
            this.loadUnderFloor();
        }

        //Send change floor event
        if (!toDelete) {
            eventsManager.instance.dispatch(Events.PLAN_FLOOR_CHANGED, PlanManager.getInstance().world.currentScene!.currentFloor);
        }
        this.scrollWindow.centerPosition(false, false);
    }
    removeCurrentFloor() {
        this.selectedEntities = [];

        if (this.world.currentScene!.floors.length > 1) {
            this.world.currentScene!.deleteFloor(PlanManager.getInstance().world.currentScene!.currentFloor!.id);
            this.saveInCache();
        }
    }
    loadWorld(world: World) {
        for (var i = 0; i < world.children.length; ++i) {
            var scene = world.children[i];
            for (var j = 0; j < scene.children.length; ++j) {
                this._lastIndexActionDone[scene.children[j].id] = -1;
                this._lastActions[scene.children[j].id] = [];
            }
        }
        this.unloadCurrentFloor();
        this.unloadUnderFloor();
        PlanManager.getInstance().world.currentScene!.currentFloor = this.world.currentScene!.floors[0];
        this._currentFloorId = PlanManager.getInstance().world.currentScene!.currentFloor!.id;
        this.loadFloorCurrentFloor();
        this.loadUnderFloor();

        //Notify that the scene has been relaoded
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
        //FIXME this should be removed ?
        eventsManager.instance.dispatch(Events.PLAN_FLOOR_CHANGED, PlanManager.getInstance().world.currentScene!.currentFloor);
        this.scrollWindow.centerPosition(false, false);
    }

    setCurrentScene(scene: Scene) {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction | IdleDecoration | FrontViewState).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction | IdleDecoration | FrontViewState).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        this.unloadCurrentFloor();
        this.unloadUnderFloor();
        this._currentFloorId = 0;
        PlanManager.getInstance().world.currentScene = scene;
        PlanManager.getInstance().world.currentScene!.currentFloor = PlanManager.getInstance().world.currentScene!.floors[0];
        this.loadFloorCurrentFloor();
        this.loadUnderFloor();

        //Notify that the scene has been relaoded
        eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
        eventsManager.instance.dispatch(Events.PLAN_FLOOR_CHANGED, PlanManager.getInstance().world.currentScene!.currentFloor);
        this.scrollWindow.centerPosition(false, false);
    }

    /**
     * Add new floor
     * @param up
     * @constructor
     */
    CreateNewFloor(floorConfig: any) {
        this.world.currentScene!.addFloor();
        var floorList = this.world.currentScene!.floors;
        // B2B, patch the world to have a none exterior
        if (isForB2B()) {
            var visit3D = true;
            var allCameras = this.world.currentScene!.renderCameras;
            for (var i = 0 ; i < allCameras.length ; i++) {
                if (allCameras[i].cameraType === SceneConstants.CameraType.PhotoRender) {
                    visit3D = false;
                    break;
                }
            }
            if (visit3D) {
                floorList[floorList.length - 1].getSun()!.exterior = 'None';
            }
        }
        var up = floorConfig.isUp;
        var id = floorList[floorList.length - 1].id;
        this._lastActions[id] = [];
        this._lastIndexActionDone[id] = -1;
        this._currentFloorId = id;
        if (up === true) {
            var maxHeight = this.getHighestFloor().getFloorMaxRoomHeight();

            floorList[floorList.length - 1].height = this.getHighestFloor().height + maxHeight + SceneConstants.DefaultInterfloorHeight;
        }
        else {
            floorList[floorList.length - 1].height = this.getLowestFloor().height - SceneConstants.DefaultWallHeight - SceneConstants.DefaultInterfloorHeight;
        }
        this.setActionCount(this._actionCount + 1);
    }

    CreateNewFloorFromImport(floorId: number) {
        this._lastActions[floorId] = [];
        this._lastIndexActionDone[floorId] = -1;
        this.setActionCount(this._actionCount + 1);
    }

    DeleteFloor(id: number) {
        this.world.currentScene!.deleteFloor(id);
        delete this._lastActions[id];
        delete this._lastIndexActionDone[id];
        this.setActionCount(this._actionCount + 1);
        this.saveInCache();
    }

    getAllFloor(): Floor[] {
        return this.world.currentScene!.floors;
    }

    getLastFloorIndex(): number {
        return this.world.currentScene!.floors[this.world.currentScene!.floors.length - 1].id;
    }

    getSortedFloor(): Floor[] {
        var i, j;
        var floorList = this.world.currentScene!.floors;
        var sortedFloorList = [];
        var sortedIndex = [];
        var bigIndex = -1;
        for (j = 0; j < floorList.length; j++) {
            for (i = 0; i < floorList.length; i++) {
                if (sortedIndex.indexOf(i) === -1) {
                    if (bigIndex === -1 || floorList[bigIndex].height < floorList[i].height)
                        bigIndex = i;
                }
            }
            sortedFloorList.push(floorList[bigIndex]);
            sortedIndex.push(bigIndex);
            bigIndex = -1;
        }
        return sortedFloorList;
    }

    getHighestFloor(): Floor {
        var j;
        var floorList = this.world.currentScene!.floors;
        var bigIndex = -1;
        for (j = 0; j < floorList.length; j++) {
            if (bigIndex === -1 || floorList[bigIndex].height < floorList[j].height)
                bigIndex = j;
        }
        return floorList[bigIndex];
    }

    getLowestFloor(): Floor {
        var j;
        var floorList = this.world.currentScene!.floors;
        var bigIndex = -1;
        for (j = 0; j < floorList.length; j++) {
            if (bigIndex === -1 || floorList[bigIndex].height > floorList[j].height)
                bigIndex = j;
        }
        return floorList[bigIndex];
    }

    /**
     * Change visibility of background image
     *
     * @param event
     */
    changeBackgroundVisibility(event: Event) {
        //console.log('Change background visibility');
        this._backgroundVisibility = event.getUserData();
        var usermap = this.scrollWindow.grid.getChildByName('UserMap');
        if (usermap !== null) {
            usermap.setVisible(this._backgroundVisibility);
        }
    }

    toggleSnap() {
        this.snapEnabled = !this.snapEnabled;
    }

    getZoomScale(): number {
        if (this.scrollWindow.isVisible()) {
            return this.scrollWindow.getZoomScale();
        } else if (this.frontViewLayer.isVisible()) {
            return this.frontViewLayer.getZoomScale();
        }

        return 1;
    }

    isFrontView(): boolean {
        if (this.frontViewLayer.isVisible()) {
            return true;
        }

        return false;
    }

    dispose() {
        this._state.dispose();
        this._uiState.dispose();
        this.scrollWindow.dispose();
    }
}